import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlEndIconColors = createInteractiveColorVar('controls-end-icon');
const ControlEndIconColorsLightValues = Object.freeze({
    default: '#525252',
    action: '#3D3D3D',
    active: '#000000',
    activeAction: '#3D3D3D',
});
const ControlEndIconColorsDarkValues = Object.freeze({
    default: '#B3B3B3',
    action: '#CCCCCC',
    active: '#FFFFFF',
    activeAction: '#CCCCCC',
});

export { ControlEndIconColors, ControlEndIconColorsDarkValues, ControlEndIconColorsLightValues };
